import React, { useEffect, useState } from "react";
import Button from "../../../../components/Buttons/button";
import { useDispatch } from "react-redux";
import { createFeedbackRequest } from "../../../../redux/slices/personalDashboardSlice";

import negativeIcon from "./../../../../assets/images/negative.png";
import negativeHoverIcon from "./../../../../assets/images/nagative_hover.png";
import neutralIcon from "./../../../../assets/images/neutral.png";
import neutralHoverIcon from "./../../../../assets/images/neutral_hover.png";
import smileyIcon from "./../../../../assets/images/smiley.png";
import smileyHoverIcon from "./../../../../assets/images/smiley_hover.png";

function FeedbackAndRequestServiceCards({ setPopup, setState, data }) {
  const [red, setred] = useState(false);
  const [yellow, setyellow] = useState(false);
  const [green, setgreen] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");

  const dispatch = useDispatch();

  const feedbackType = green
    ? "positive"
    : yellow
    ? "general"
    : red
    ? "negative"
    : "";

  const handleSubmit = () => {
    if (feedbackType) {
      dispatch(
        createFeedbackRequest({
          service_id: data?.service?.id,
          user_id: data?.user?.id,
          rating: feedbackType,
          feedback_details: feedbackText,
        })
      );
      setFeedbackText("");
      setred("");
      setgreen("");
      setyellow("");
    }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-10 justify-center">
      <div className="flex flex-col bg-[#363D50] rounded-[24px] gap-[8px] max-w-[100%] px-[24px] pb-[24px]">
        <div className="flex flex-col pt-[24px]">
          <div className="flex flex-col md:flex-row md:justify-between pb-[16px] gap-[16px]">
            <div className="flex justify-start gap-[16px] items-center">
              <div className="flex justify-center items-center bg-[#242B3E] p-[12px] rounded-[16px] w-14 h-14">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.24461 9.16792C10.061 8.66032 11.0568 8.52991 11.9764 8.81018L18.683 10.8542C19.6027 11.1345 20.0557 12.169 19.6379 13.035C19.3128 13.7087 18.557 14.0588 17.8329 13.8712L14.4674 12.9994C14.3997 12.9811 14.3312 12.974 14.264 12.9771C14.062 12.9862 13.8747 13.0876 13.7562 13.2495C13.7127 13.3089 13.6785 13.3765 13.6562 13.4507C13.6337 13.5248 13.6249 13.6 13.6283 13.6736C13.6405 13.9433 13.817 14.1866 14.0825 14.2753L16.7628 15.2012C17.655 15.5093 18.6196 15.5397 19.5294 15.2883L26.6989 13.3072C27.2024 13.168 27.7393 13.3564 28.0455 13.7795C28.4569 14.3479 28.3205 15.1434 27.7432 15.5422L19.3132 21.3658C18.5011 21.9269 17.4822 22.0991 16.5308 21.8362L9.20468 19.8118C8.79984 19.6999 8.38174 19.6432 7.96173 19.6432H4.6441C4.27591 19.6432 3.97743 19.9417 3.97743 20.3099C3.97743 20.6781 4.27591 20.9766 4.6441 20.9766H7.96173C8.26174 20.9766 8.56038 21.0171 8.84955 21.097L16.1756 23.1214C17.5076 23.4894 18.9341 23.2483 20.0711 22.4629L28.501 16.6393C29.6936 15.8154 29.9755 14.1719 29.1256 12.9977C28.493 12.1236 27.3838 11.7346 26.3438 12.022L20.8766 13.5327C21.5833 11.9475 20.7449 10.0887 19.0718 9.57878L12.3651 7.53477C11.0777 7.14239 9.68358 7.32496 8.5406 8.0356L3.64874 11.0771C3.33606 11.2715 3.24017 11.6826 3.43458 11.9952C3.62899 12.3079 4.04007 12.4038 4.35275 12.2094L9.24461 9.16792Z"
                    fill="white"
                  />
                </svg>
              </div>

              <div className="flex flex-start flex-col gap-[2px]">
                <div className="flex text-primary !text-[16px] !leading-[24px]">
                  Give feedback
                </div>
                <span className="text-secondary !text-[14px] !leading-[20px]">
                  Tell us anything about this service
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col p-[16px] gap-[10px] justify-end items-start border-[1px] border-[#434A5D] rounded-[16px] ">
          <div className="flex gap-[8px] w-[100%] h-[225px]">
            <textarea
              className="resize-none w-[100%] p-1.5 scrollbar-hide !text-[18px] !leading-[27px] border-none focus:ring-0 bg-[#363D50] placeholder:text-lg placeholder:font-normal placeholder:text-grey-blue-200"
              placeholder="This service would better suite me if..."
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
            ></textarea>{" "}
          </div>

          <div className="w-[100%] h-px bg-[#434A5D]" />

          <div className="w-[100%] flex flex-col md:flex-row md:justify-end lg:justify-end lg:items-center gap-[16px]">
            <div className="flex gap-[8px] items-center">
              <span className="text-secondary !leading-[16px]">
                Select feedback type
              </span>
              <div
                onClick={() => {
                  setgreen(!green);
                  setred(false);
                  setyellow(false);
                }}
                className={`${
                  green
                    ? "active cursor-pointer good rating_wrapper"
                    : "false cursor-pointer good rating_wrapper"
                }`}
              >
                <img
                  src={smileyIcon}
                  alt="rating-img"
                  className="rating_icon inactive"
                />
                <img
                  src={smileyHoverIcon}
                  alt="rating-img"
                  className="rating_icon active"
                />
              </div>
              <div
                onClick={() => {
                  setgreen(false);
                  setred(false);
                  setyellow(!yellow);
                }}
                className={`${
                  yellow
                    ? "active cursor-pointer face rating_wrapper"
                    : "false cursor-pointer face rating_wrapper"
                }`}
              >
                <img
                  src={neutralIcon}
                  alt="rating-img"
                  className="rating_icon inactive"
                />
                <img
                  src={neutralHoverIcon}
                  alt="rating-img"
                  className="rating_icon active"
                />
              </div>
              <div
                onClick={() => {
                  setgreen(false);
                  setred(!red);
                  setyellow(false);
                }}
                className={`${
                  red
                    ? "active cursor-pointer face rating_wrapper"
                    : "false cursor-pointer face rating_wrapper"
                }`}
              >
                <img
                  src={negativeIcon}
                  alt="rating-img"
                  className="rating_icon inactive"
                />
                <img
                  src={negativeHoverIcon}
                  alt="rating-img"
                  className="rating_icon active"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <Button
                onClick={handleSubmit}
                outlined={true}
                hoverColor={true}
                secondary={true}
                secondaryHoverOutlined={true}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col bg-[#363D50] rounded-[24px] gap-[8px] max-w-[100%] px-[24px] pb-[24px]">
        <div className="flex flex-col pt-[24px]">
          <div className="flex items-center pb-[16px] gap-[16px]">
            <div className="flex justify-center items-center bg-[#242B3E] p-[12px] rounded-[16px] w-14 h-14 gap-[10px]">
              <svg
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.16634 9.33333C5.16634 8.22876 6.06177 7.33333 7.16634 7.33333H25.833C26.9376 7.33333 27.833 8.22876 27.833 9.33333V20C27.833 21.1046 26.9376 22 25.833 22H20.2709C19.3869 22 18.539 22.3512 17.9139 22.9763L12.6949 28.1953C12.4346 28.4556 12.4346 28.8777 12.6949 29.1381C12.9553 29.3984 13.3774 29.3984 13.6377 29.1381L18.8567 23.9191C19.2318 23.544 19.7405 23.3333 20.2709 23.3333H25.833C27.674 23.3333 29.1663 21.8409 29.1663 20V9.33333C29.1663 7.49238 27.674 6 25.833 6H7.16634C5.32539 6 3.83301 7.49238 3.83301 9.33333V20C3.83301 21.8409 5.32539 23.3333 7.16634 23.3333H11.833C12.2012 23.3333 12.4997 23.0349 12.4997 22.6667C12.4997 22.2985 12.2012 22 11.833 22H7.16634C6.06177 22 5.16634 21.1046 5.16634 20V9.33333ZM11.1663 14C10.7982 14 10.4997 14.2985 10.4997 14.6667C10.4997 15.0349 10.7982 15.3333 11.1663 15.3333H11.1797C11.5479 15.3333 11.8463 15.0349 11.8463 14.6667C11.8463 14.2985 11.5479 14 11.1797 14H11.1663ZM16.4997 14C16.1315 14 15.833 14.2985 15.833 14.6667C15.833 15.0349 16.1315 15.3333 16.4997 15.3333H16.513C16.8812 15.3333 17.1797 15.0349 17.1797 14.6667C17.1797 14.2985 16.8812 14 16.513 14H16.4997ZM21.833 14C21.4648 14 21.1663 14.2985 21.1663 14.6667C21.1663 15.0349 21.4648 15.3333 21.833 15.3333H21.8463C22.2145 15.3333 22.513 15.0349 22.513 14.6667C22.513 14.2985 22.2145 14 21.8463 14H21.833Z"
                  fill="white"
                />
              </svg>
            </div>

            <div className="flex flex-start flex-col gap-[2px]">
              <div className="flex gap-[2px] text-primary !text-[16px] !leading-[24px]">
                Make a request
              </div>
              <span className="text-secondary !text-[14px] !leading-[20px]">
                What to you want to do with this service?
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col min-h-[330px]">
          <div className="flex flex-col min-h-[266px] gap-4">
            <div
              onClick={() => {
                setPopup(true);
                setState(7);
              }}
              className="flex flex-col p-[4px] gap-[10px] hover:cursor-pointer"
            >
              <div className="flex card-animate py-[16px] px-[24px] gap-[16px] border-[1px] rounded-[16px] border-[#41485C]">
                <div className="flex flex-col gap-[4px]">
                  <span className="text-primary !text-[16px] !font-semibold">
                    Suggest service change
                  </span>
                  <span className="text-secondary">
                    Make suggestions to management for changes to this service,
                    so it might better suit you, your team, or your company’s
                    needs.
                  </span>
                </div>
              </div>
            </div>

            <div
              onClick={() => {
                setPopup(true);
                setState(6);
              }}
              className="flex flex-col p-[4px] gap-[10px] hover:cursor-pointer"
            >
              <div className="flex card-animate py-[16px] px-[24px] gap-[16px] border-[1px] rounded-[16px] border-[#41485C]">
                <div className="flex flex-col gap-[4px]">
                  <span className="text-primary !text-[16px] !font-semibold">
                    Suggest that you be opted-out of this service
                  </span>
                  <span className="text-secondary">
                    If you don't think this service is working or just don’t use
                    it, request to opt-out.
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-6 flex flex-col">
            <span className="text-secondary !leading-[20px]">
              Thinking of a replacement service? Tell us about it by{" "}
            </span>
            <span
              onClick={() => {
                setPopup(true);
                setState(1);
              }}
              className="text-secondary underline hover:cursor-pointer !text-[#FFD74A] !leading-[20px]"
            >
              Submitting a new service!
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeedbackAndRequestServiceCards;
